import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { PageHeader } from "../components/PageHeader";
import { LiveStream } from "../components/LiveStream";

export const LivePage = () => {
    return (
        <div data-testid="live-page">
            <PageHeader
                eyebrow="The Live Den"
                title="Tune in to the"
                accent="signal."
                intro="Player on the left, chat on the right. If the stream's offline, swing through the schedule — the next session is never far away."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "Live" }]}
            />
            <LiveStream />

            <section className="py-10">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-wrap gap-3">
                    <Link
                        to="/schedule"
                        className="btn-sweep inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 border border-white/10 text-white text-sm hover:border-white/30 transition"
                        data-testid="live-to-schedule"
                    >
                        See full schedule <ArrowRight size={14} weight="bold" />
                    </Link>
                    <Link
                        to="/clips"
                        className="btn-sweep inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/5 border border-white/10 text-white text-sm hover:border-white/30 transition"
                        data-testid="live-to-clips"
                    >
                        Watch recent clips <ArrowRight size={14} weight="bold" />
                    </Link>
                </div>
            </section>
        </div>
    );
};
